import { TranslatedString, useAppConfig } from "@ct-react/core";
import { useLocaleContext, useLocaleUrl } from "@ct-react/locale";
import { allLocales } from "@shared/locale";

type Props = {
  title?: string | TranslatedString;
  description?: string | TranslatedString;
  image?: string;
  keywords?: string[];
  canonical?: string;
}

const SeoMetas = (props: Props) => {

  const { locale } = useLocaleContext();
  const { canonicalBaseUrl: baseUrl } = useAppConfig();
  const { buildLocaleHref } = useLocaleUrl(baseUrl);

  const title = typeof props.title === "string" ? props.title : props.title?.value;
  const description = typeof props.description === "string" ? props.description : props.description?.value;

  return (
    <>
      {!!title &&
        <>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </>
      }
      {!!description &&
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
        </>
      }
      {!!props.image &&
        <meta property="og:image" content={props.image} />
      }
      {!!(props.keywords && props.keywords.length > 0) &&
        <meta name="keywords" content={props.keywords.join(", ")} />
      }
      {!!props.canonical && allLocales.map((loc, index) => (
        <link key={index}
              rel={locale.code === loc.code ? "canonical" : "alternate"}
              {...(locale.code !== loc.code && { hrefLang: loc.code })}
              href={buildLocaleHref(props.canonical!, loc)} />)
      )}
    </>);
}

export default SeoMetas;
